import React, { useState } from 'react';
import { Button, CircularProgress, LinearProgress, Typography } from '@mui/material';

export const MgpUploadButton = ({ label, name, onChange, multiple, accept }) => {
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadStatus, setUploadStatus] = useState('');

  const handleUpload = (event) => {
    setUploading(true);
    setUploadProgress(0);
    setUploadStatus('Uploading...');

    const files = event.target.files;
    const totalSize = Array.from(files).reduce((acc, file) => acc + file.size, 0);
    let uploaded = 0;

    const uploadFile = (file) => {
      return new Promise((resolve) => {
        // Simulating upload progress
        const interval = setInterval(() => {
          uploaded += 1024 * 10; // Increment by 10KB for simulation
          const progress = Math.min((uploaded / file.size) * 100, 100);
          setUploadProgress(progress);

          if (progress >= 100) {
            clearInterval(interval);
            resolve();
          }
        }, 200);
      });
    };

    Promise.all(Array.from(files).map(uploadFile))
      .then((statuses) => {

        setUploadStatus('Upload successful');
        const overallStatus = statuses.every((status) => status === 'success') ? 'success' : 'failure';
        onChange(event, overallStatus);
      })
      .catch((err) => {
        onChange(event, 'failure');
        setUploadStatus('Upload failed');
      })
      .finally((statuses) => {
        setUploading(false);
        const overallStatus = statuses?.every((status) => status === 'success') ? 'success' : 'failure';
        onChange(event, overallStatus);
      });

    onChange(event);
  };

  return (
    <>
      <input
        id={name}
        type="file"
        inputProps={{ multiple, accept }}
        onChange={handleUpload}
        style={{ display: 'none' }}
      />
      <label htmlFor={name}>
        <Button variant="contained" component="span">
          {label}
        </Button>
      </label>
      {uploading && (
        <div style={{ marginTop: '10px' }}>
          <LinearProgress variant="determinate" value={uploadProgress} />
          <Typography variant="body2" color="textSecondary" style={{ marginTop: '5px' }}>
            {uploadStatus}
          </Typography>
        </div>
      )}
    </>
  );
};

